<template>
    <v-container>
        <div class="headline mt-9 mb-9">
            Meine Geräte
        </div>
        <v-row>
            <DialogShowVideo ref="dlgVideo"></DialogShowVideo>
            <DialogShowVideoHoch ref="dlgVideoHoch"></DialogShowVideoHoch>
            <v-col cols="12" xs="12" sm="6" md="6" lg="6" v-for="device in devices" :key="device.id">
                <WidgetDevice :device="device"></WidgetDevice>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    //import Vue from 'vue'
    import DialogShowVideo from '@/components/module/dialogs/DialogShowVideo'
    import DialogShowVideoHoch from '@/components/module/dialogs/DialogShowVideoHoch'
    import WidgetDevice from "./widgets/WidgetDevice";

    export default {
        name: 'WidgetMeineGeraete',
        components: {WidgetDevice, DialogShowVideoHoch, DialogShowVideo},
        props: ['devices'],
        data() {
            return {
                numberOfItemsCard: '15 Items',
                titleGeraete: 'Mein Gerät ...',
                playlistName: 'Name der Playlist',
                model1: null,
                model: null,
            }
        },
        methods: {
            openDialog: function () {
                this.$refs.dlgVideo.open()
            },
            openDialogHoch: function () {
                this.$refs.dlgVideoHoch.open()
            },
            onPickFile() {
                this.$refs.fileInput.click()
            },
            onFilePicked(event) {
                const files = event.target.files
                if (files[0] !== undefined) {
                    this.fileName = files[0].name
                    // Check validity of file
                    if (this.fileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    // If valid, continue
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.url = fr.result
                        this.fileObject = files[0] // this is an file that can be sent to server...

                    })
                } else {
                    this.fileName = ''
                    this.fileObject = null
                    this.url = ''
                }
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>
